import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ProductComparisonPageInitialData } from "./productComparisonPageInitialData";

function buildProductComparisonPagePath(productCode: string | null): string {
  const path = "/page-data/product-comparison";
  return productCode ? `${path}?productCode=${encodeURIComponent(productCode)}` : path;
}

export const productComparisonPageQueryOptions = (productCode: string | null) =>
  queryOptions({
    queryKey: pageDataKeys.productComparison(productCode),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<ProductComparisonPageInitialData>>(
        buildProductComparisonPagePath(productCode),
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
